import { ReactElement } from "react";
import "../../css/TeeStyles.css";

interface content {
  content: string;
}
const SectionOne = ({ content }: content): ReactElement => {
  return (
    <div
      data-aos="fade-right"
      className="my-image-bookings pt-6 pb-6 text-center white fontSize64px boldSeven section"
    >
      {content}
    </div>
  );
};

export default SectionOne;
